import { useStudyText } from '@/i18n/studyText';
import { studentApi } from '../api';
import type { FC } from 'react';
import type { StudentDocumentTemplate } from '../types';
import { DownloadIcon } from './CourseStudentIcons';

interface StudentDocumentModalProps {
  isOpen: boolean;
  template: StudentDocumentTemplate | null;
  onClose: () => void;
}

export const StudentDocumentModal: FC<StudentDocumentModalProps> = ({
  isOpen,
  template,
  onClose,
}) => {
  const st = useStudyText();
  if (!isOpen || !template) return null;

  return (
    <div className="cab-overlay">
      <div className="cab-shell cab-shell--wide cab-shell--tall">
        <div className="flex items-center justify-between border-b border-slate-800 pb-3">
          <div>
            <span className="text-[10px] font-bold uppercase tracking-wider text-cyan-400">
              {template.category}
            </span>
            <h3 className="text-base font-bold text-white mt-0.5">{template.title}</h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="text-slate-400 hover:text-white"
            aria-label={st("Закрыть")}
          >
            ✕
          </button>
        </div>

        <div className="p-4 rounded-xl bg-slate-900/80 border border-slate-800 space-y-2 text-xs text-slate-300 leading-relaxed">
          <p className="font-semibold text-slate-200">{st("Описание и правила оформления:")}</p>
          <p>{template.description}</p>
          <div className="pt-2 border-t border-slate-800/80 flex items-center justify-between text-[11px] text-slate-400">
            <span>{st("Формат файла:")}{template.file_type}</span>
            <span>{st("Размер:")}{template.size_label}</span>
          </div>
        </div>

        <div className="pt-3 border-t border-slate-800 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-xl border border-slate-700 hover:bg-slate-800 text-xs font-semibold text-slate-300"
          >
            {st("Закрыть")}</button>
          <button
            type="button"
            onClick={() => void studentApi.downloadCourseFile(template.download_url)}
            className="px-5 py-2 rounded-xl bg-[#E5A83B] hover:bg-[#D4982E] text-slate-950 text-xs font-bold transition-all shadow-md flex items-center gap-1.5"
          >
            <DownloadIcon className="w-3.5 h-3.5" />
            {st("Скачать шаблон")}</button>
        </div>
      </div>
    </div>
  );
};
